<template>
  <div>
    <div class="fixed-bottom">
      <p>{{userEmail}}</p>
      <button class="btn text-link  mx-auto" @click="logout">
        Logout
      </button>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    logout(){
      swal({
        title: "Are you sure?",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      })
      .then((willDelete) => {
        if (willDelete) {
          this.$axios.delete('logout')
            .then(res => {
              if(res.data.status == true){
                localStorage.removeItem('s-o-token');
                localStorage.removeItem('s-o-user-name');
                localStorage.removeItem('s-o-user-email');
                this.$router.replace('/login');
                return;
              }
            })
            .catch(err => console.log(err));
        }
      });
    }
  },
  computed: {
    userEmail(){
      return localStorage.getItem('s-o-user-email')
    }
  }
}
</script>
